// @flow
import dealsService from './dealsService';
import dealsActionKeys from './dealsActionKeys';

export const API_LIMIT = 10;

const getCoupons = (serviceProviderId: string): {|
  payload: {|data: {|serviceProviderId: string|}, promise: any|},
  type: string,
|} => ({
  type: dealsActionKeys.GET_COUPONS,
  payload: {
    data: { serviceProviderId },
    promise: dealsService.getCoupons(serviceProviderId),
  },
});

const getDeals = (serviceProviderId: string, offset: number = 0): {|
  payload: {|
    data: {|limit: number, offset: number, serviceProviderId: string|},
    promise: any,
  |},
  type: string,
|} => ({
  type: dealsActionKeys.GET_DEALS,
  payload: {
    data: {
      serviceProviderId,
      offset,
      limit: API_LIMIT,
    },
    promise: dealsService.getDeals(serviceProviderId, offset, API_LIMIT),
  },
});

export default {
  getCoupons,
  getDeals,
};



// WEBPACK FOOTER //
// ./src/modules/store/common/dealsActions.js